import {
  Component,
  computed,
  input,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { TooltipOptions } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

export type ButtonType =
  | 'destructive-primary'
  | 'destructive-secondary'
  | 'destructive-tertiary'
  | 'neutral-secondary'
  | 'neutral'
  | 'tertiary'
  | 'alternative'
  | 'brand-secondary'
  | 'default'
  | 'button-chip';

@Component({
    selector: 'lib-global-button',
    imports: [ButtonModule, TooltipModule],
    templateUrl: './global-button.component.html',
    styleUrl: './global-button.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: { '[attr.data-id]': 'uniqueId' }
})
export class GlobalButtonComponent implements OnInit {
  public icon = input<string>('');
  public iconPosition = input<'left' | 'right'>('right');
  public isLoading = input(false);
  public timeOut = input(false);
  @Input({ required: true }) type: ButtonType = 'default';
  @Input() label: string = '';
  @Input() tooltipShow: boolean = false;
  @Input() disable: boolean = false;
  @Input() tooltipLabel: string = '';
  @Input() badges!: string;
  @Input() buttonType: 'button' | 'submit' | 'reset' = 'button';
  uniqueId = `global-button-${Math.random().toString(36).slice(2, 11)}`;
  public tooltipOptions: TooltipOptions = {};

  public renderedIcon = computed(() => {
    return this.isLoading() ? 'pi pi-spinner pi-spin' : this.icon();
  });

  ngOnInit(): void {
    this.tooltipOptions = {
      disabled: !this.tooltipShow,
    };
  }
}
